import { Divider } from "antd";
import Scaffold from "Components/Scaffold";
import { useGetMeQuery } from "hooks/Auth/useGetMeQuery";
import DashboardLayout from "Layout/DashboardLayout";
import React from "react";
import Moment from "react-moment";

const Profile = () => {
  const { data: user } = useGetMeQuery();

  return (
    <DashboardLayout title="Profile" back={false}>
      <div className="px-[20px] mt-[20px] max-w-[500px] mx-auto">
        <Scaffold left="Information">
          <div className="px-2">
            <h3 className="text-[#a8a8a8] mb-[2px]">Full Name</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.firstName
                ? user?.data?.firstName + " " + user?.data?.lastName
                : "n/a"}
            </p>
            {/* <Divider /> */}
            <h3 className="text-[#a8a8a8] mb-[2px]">Email Address</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.email ? user?.data?.email : "n/a"}
            </p>
            <h3 className="text-[#a8a8a8] mb-[2px]">Phone Number</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.phoneCountryCode} {user?.data?.phoneNumber || "N/A"}{" "}
            </p>

            <h3 className="text-[#a8a8a8] mb-[2px]">Created on</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.createdAt ? (
                <Moment
                  interval={0}
                  format="DD-MM-YYYY hh:mm a"
                  className="text-black"
                >
                  {user?.data?.createdAt}
                </Moment>
              ) : (
                "n/a"
              )}
            </p>
            <h3 className="text-[#a8a8a8] mb-[2px]">Last Login</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.lastLogin ? (
                <Moment
                  interval={0}
                  format="DD-MM-YYYY hh:mm a"
                  className="text-black"
                >
                  {user?.data?.lastLogin}
                </Moment>
              ) : (
                "n/a"
              )}
            </p>
            <Divider />
            <h3 className="text-[#a8a8a8] mb-[2px]">Role</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.role ? user?.data?.role?.name : "n/a"}
            </p>
            <h3 className="text-[#a8a8a8] mb-[2px]">Description</h3>
            <p className="text-black mb-[15px]">
              {user?.data?.role ? user?.data?.role?.description : "n/a"}
            </p>
            <Divider />
            <h3 className="text-black font-bold mb-4">Permission(s)</h3>
            <div>
              {user?.data?.role?.permission
                ? user?.data?.role?.permission.map(
                    ({
                      module,
                      id,
                      create,
                      read,
                      update,
                      delete: del,
                    }: any) => (
                      <div key={id} className="mb-3">
                        <h3 className="text-[#a8a8a8] font-bold">
                          {module.name}
                        </h3>
                        <p className="text-black">{module.description}</p>
                        <div className="flex gap-2 mt-3 text-ash">
                          <span>
                            Create:{" "}
                            <span
                              className={
                                create ? "text-green-500" : "text-red-500"
                              }
                            >
                              {create ? "Yes" : "No"}
                            </span>
                          </span>
                          <span>
                            Read:{" "}
                            <span
                              className={
                                read ? "text-green-500" : "text-red-500"
                              }
                            >
                              {read ? "Yes" : "No"}
                            </span>
                          </span>
                          <span>
                            Update:{" "}
                            <span
                              className={
                                update ? "text-green-500" : "text-red-500"
                              }
                            >
                              {update ? "Yes" : "No"}
                            </span>
                          </span>
                          <span>
                            Delete:{" "}
                            <span
                              className={
                                del ? "text-green-500" : "text-red-500"
                              }
                            >
                              {del ? "Yes" : "No"}
                            </span>
                          </span>
                        </div>
                      </div>
                    )
                  )
                : "N/A"}
            </div>
          </div>
        </Scaffold>
      </div>
    </DashboardLayout>
  );
};

export default Profile;
